import { Label } from "@/components/shadcn/label";

interface Props {
  label: string;
  children?: React.ReactNode;
}

export function FilterRowChartItem({ label, children }: Props) {
  return (
    <div className="flex flex-row gap-2">
      <Label>{label}</Label>
      {children}
    </div>
  );
}